export enum OperationType {
  TO_PROCESS = 'TO_PROCESS',
  PENDING = 'PENDING',
  SALE = 'SALE',
  TRADE = 'TRADE',
  EXPIRED_UNUSED_TICKETS = 'EXPIRED_UNUSED_TICKETS',
  USE_TICKETS = 'USE_TICKETS',
  BROKEN = 'BROKEN',
  CREATE_STOCK = 'CREATE_STOCK',
  DELETE_STOCK = 'DELETE_STOCK',
  INVENTORY_IN = 'INVENTORY_IN',
  INVENTORY_OUT = 'INVENTORY_OUT',
  BALANCE_IN = 'BALANCE_IN',
  BALANCE_OUT = 'BALANCE_OUT',
  IN = 'IN',
  OUT = 'OUT',
  THEFT = 'THEFT',
  RELOCATE_IN = 'RELOCATE_IN',
  RELOCATE_OUT = 'RELOCATE_OUT',
  COLLABORATIVE = 'COLLABORATIVE',
  COLLABORATIVE_BALANCE = 'COLLABORATIVE_BALANCE',
  INVENTORY = 'INVENTORY',
  SHIPMENT = 'SHIPMENT',
  CONTESTED = 'CONTESTED',
  VOUCHER_TRANSFER = 'VOUCHER_TRANSFER'
}
